import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { MAILSTATUS } from '../utils/constants';
import { StatusMail } from 'models/response';

/**
 * get mail status dashboard
 * @return {Promise<AxiosResponse>}
 */
const getMailStatus = () => trackPromise(axios.get<StatusMail[]>(`${MAILSTATUS}/getMailStatus`), 'module');

export default {
  getMailStatus,
};
